import { useCallback, useState } from "react";
import useFetch, { ServiceParams, ServiceResponse } from "../hooks/useFetch";
import EndPoints from "../config/EndPoint";
import { ServiceEmailNoteCreate } from "../models/ServiceEmailNoteModel";

type Events = Partial<{
  onSuccess: (r: ServiceResponse) => void;
  onError: (r: ServiceResponse) => void;
}>;

const useServiceEmailNotesService = () => {
  const { doGet, doPost } = useFetch();
  const [fetching, setFetching] = useState<Record<string, boolean>>({});

  const setFlag = useCallback((key: string, value: boolean) => {
    setFetching((prev) => ({ ...prev, [key]: value }));
  }, []);

  const listByEmail = useCallback(
    (emailId: number, events: Events = {}, signal?: AbortSignal) =>
      doGet({
        url: EndPoints.SERVICES.EMAILS_NOTES.replace(":id", String(emailId)),
        setFetching: (value) => setFlag("list", value),
        signal,
        ...events,
      } as ServiceParams),
    [doGet, setFlag]
  );

  const store = useCallback(
    (emailId: number, payload: ServiceEmailNoteCreate, events: Events = {}) =>
      doPost({
        url: EndPoints.SERVICES.EMAILS_NOTES.replace(":id", String(emailId)),
        body: payload,
        setFetching: (value) => setFlag("store", value),
        ...events,
      } as ServiceParams),
    [doPost, setFlag]
  );

  return {
    fetching,
    listByEmail,
    store,
  };
};

export default useServiceEmailNotesService;
